<hvac-link class='hvac-content-card hvac-icon-content-card'  [link]="cardContent.link" [linkType]="cardLinkType">
    <div class='hvac-content-card-content-container hvac-icon-content-card-container'>
        <div class='hvac-icon-content-card-header-container'>
            <div class='hvac-icon-content-card-image-background'><img class='hvac-icon-content-card-image' *ngIf="cardContent.imgSrc" [src]="cardContent.imgSrc" /></div>
            <h3 class='hvac-icon-content-card-header' [innerHTML]="cardContent.title | richText"></h3>
        </div>
        <p class='hvac-content-card-body' [innerHTML]="cardContent.body | richText | textOverflow:maxBodyLength"></p>
    </div>
</hvac-link>
